const dbCat = {
  1: 15,
  2: 24,
  3: 28,
  4: 32,
  5: 36,
  6: 40,
  7: 44,
  8: 48,
  9: 52,
  10: 56,
  11: 60,
  12: 64,
  13: 68,
  14: 72,
  15: 76,
  16: 80,
  17: 84,
  18: 88,
  19: 92,
  20: 96,
  21: 100,
  22: 104,
  23: 108,
  24: 112,
  25: 116,
};

export default dbCat;
